import { useEffect, useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiGet, type Provider } from "../api/client";
import { PageHeader } from "../components/PageHeader";

/** Historical invite patient form (`add-patient.html` / app.add-patient). */
export function AddPatientPage() {
  const navigate = useNavigate();
  const [doctors, setDoctors] = useState<Provider[]>([]);
  const [doctorId, setDoctorId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    apiGet<Array<{ providers?: Provider[]; doctors?: Provider[] }>>("/doctors")
      .then((d) => {
        const row = Array.isArray(d) ? d[0] : d;
        setDoctors(row?.providers || row?.doctors || []);
      })
      .catch(() => setDoctors([]));
  }, []);

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!doctorId || !firstName || !lastName || !email || !phone) return;
    setDone(true);
    // Archive cannot persist — return to patients list after a beat.
    window.setTimeout(() => navigate("/app/patients"), 800);
  }

  return (
    <>
      <PageHeader title="Invite a patient" />
      <form
        className="ne__add-patient"
        onSubmit={onSubmit}
        noValidate
        style={{ padding: "2.5vw 5%", maxWidth: 480 }}
      >
        <div className="ne__fieldset__group">
          <fieldset className="ne__fieldset">
            <label>
              <select
                className="ne__select"
                name="doctorId"
                value={doctorId}
                onChange={(e) => setDoctorId(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Provider
                </option>
                {doctors.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name}
                    {d.meta_type || d.friendly_type
                      ? ` (${d.friendly_type || d.meta_type})`
                      : ""}
                  </option>
                ))}
              </select>
              <i className="ne__icon__arrow--dropdown" />
            </label>
          </fieldset>
          <fieldset className="ne__fieldset">
            <label>
              <input
                className="ne__input"
                type="text"
                name="firstName"
                required
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <span className="ne__placeholder">First Name</span>
            </label>
          </fieldset>
          <fieldset className="ne__fieldset">
            <label>
              <input
                className="ne__input"
                type="text"
                name="lastName"
                required
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              <span className="ne__placeholder">Last Name</span>
            </label>
          </fieldset>
          <fieldset className="ne__fieldset">
            <label>
              <input
                className="ne__input"
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <span className="ne__placeholder">Email</span>
            </label>
          </fieldset>
          <fieldset className="ne__fieldset">
            <label>
              <input
                className="ne__input"
                type="tel"
                name="number"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <span className="ne__placeholder">Phone</span>
            </label>
          </fieldset>
        </div>
        <button
          type="submit"
          className="ne__btn ne__btn--primary ne__btn--md"
          style={{ marginTop: "1.5rem" }}
        >
          Send invite
        </button>
        {done ? (
          <p style={{ marginTop: "1rem" }}>
            Invite staged (archive is read-only). Returning to patients…
          </p>
        ) : null}
        <p style={{ marginTop: "1.5rem" }}>
          <Link to="/app/patients">← Back to patients</Link>
        </p>
      </form>
    </>
  );
}
